// maintain alphabetical order
export const enMetrics = {
  Auctions: 'Auctions',
  BidResponseRate: 'Bid Response Rate',
  BidTimeoutRate: 'Bid Timeout Rate',
  BidWinRate: 'Bid Win Rate',
  CPM: 'CPM',
  CPMPerSecond: 'CPM Per Second',
  EndpointBlockedEndpointShield: 'Endpoint Block - Endpoint Shield',
  EndpointRequestsECPM: 'Endpoint Requests ECPM',
  FillRate: 'Fill Rate',
  PaidPodClearRate: 'Paid Pod Clear Rate',
  PodClearRate: 'Pod Clear Rate',
  PodFillRate: 'Pod Fill Rate',
  RenderRate: 'Render Rate',
  WinningBids: 'Winning Bids',
};